/**
 * @typedef {object} UIConfiguration
 * @property {boolean=} isTouchScreen - apply touch screen-specific styles
 * */

/** @type {UIConfiguration} config */
export const config = {
  isTouchScreen: false
};

/** @param {UIConfiguration} newConfig */
export const setConfiguration = newConfig => {
  Object.assign(config, newConfig);
};